import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import add from './add.js'
import dropdown from './dropdown.js'
import edit from './edit.js'
import editing from './editing.js'
import item from './item.js'
import list from './list.js'
import remove from './remove.js'

export default contract({
  add: array([
    add
  ]),
  dropdown: array([
    dropdown
  ]),
  edit: array([
    edit
  ]),
  editing: array([
    editing
  ]),
  item: array([
    item
  ]),
  list: array([
    list
  ]),
  remove: array([
    remove
  ])
})
